import * as React from "react";

import "./details-table.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {chain}          from "@Common/utils/fs";
import {COMPANY_LEVEL} from "@Xpresso/routes/common/logic/user-level";

export const DetailsTable = ({history}) => cs(
    consumeContext("userLevels"),
    ({userLevels}) => (
        <div className="details-table-5dd">
            <div className="table">

                <div className="line">
                    <div className="label" xd-qa-type="label" xd-qa-name="Program">
                        Program
                    </div>
                    <div className="value"xd-qa-type="label" xd-qa-name={history?.name || history?.idProgram}>
                        {history?.name || history?.idProgram}
                    </div>
                </div>
                {userLevels.userLevel === COMPANY_LEVEL && (
                    <div className="line">
                        <div className="label" xd-qa-type="label" xd-qa-name="Office">
                            Office
                        </div>
                        <div className="value" xd-qa-type="label" xd-qa-name={history?.branchName}>
                            {history?.branchName}
                        </div>
                    </div>
                )}

                <div className="line">
                    <div className="label" xd-qa-type="label" xd-qa-name="User">
                        User
                    </div>
                    <div className="value">
                        <div className="line" xd-qa-type="label" xd-qa-name={history?.fullName}>
                            {history?.fullName}
                        </div>
                        {chain(
                            [
                                userLevels.internalUser && history?.idUser,
                                history?.agentEmail,
                            ].filter(v=>v),
                            (_) => !_.length ? null : (
                                <div className="line" xd-qa-type="label" xd-qa-name={"(" + _.join(", ") + ")"}>
                                    {"(" + _.join(", ") + ")"}
                                </div>
                            ),
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
);
